export default __webpack_public_path__ + "media/images/brighteon-social/Icon-New-Brighteon-Gray-6143e8d554d943ff16e704be5adbf522.svg";